//@flow
import * as React from 'react';
import theme from './FullScreenIcon.scss';
import Icon from 'common/components/core/icon';
import { TooltipDiv } from 'common/components/core/wrappers/Div';
import FullscreenHelper from 'common/helpers/FullscreenHelper';
import { translate } from 'react-i18next';

type Props = {
    isFullScreen: boolean,
    theme: Object,
    toggleFullScreen: boolean => void
};

class FullScreenIcon extends React.Component<Props, void> {
    static defaultProps = {
        isFullScreen: false
    };

    componentDidMount() {
        FullscreenHelper.addFullScreenChangeListener(this.toggleButtonState);
    }

    componentDidUpdate(prevProps: Props) {
        const { isFullScreen } = this.props;
        const { isFullScreen: oldIsFullScreen } = prevProps;
        if (isFullScreen !== oldIsFullScreen) {
            this.toggleBrowserFullScreen(isFullScreen);
        }
    }

    componentWillUnmount() {
        FullscreenHelper.removeFullScreenChangeListener(this.toggleButtonState);
    }

    toggleBrowserFullScreen(isFullScreen: boolean) {
        if (isFullScreen) {
            FullscreenHelper.enable();
        } else {
            FullscreenHelper.disable();
        }
    }

    toggleButtonState = () => {
        const { toggleFullScreen, isFullScreen } = this.props;
        if (FullscreenHelper.isEnabled() && !isFullScreen) {
            toggleFullScreen(false);
        } else if (!FullscreenHelper.isEnabled() && isFullScreen) {
            toggleFullScreen(true);
        }
    };

    onButtonClick = () => {
        const { toggleFullScreen, isFullScreen } = this.props;
        toggleFullScreen(isFullScreen);
    };

    render() {
        const { isFullScreen, t } = this.props;
        return (
            <TooltipDiv
                theme={theme}
                tooltipPosition="bottom"
                invert
                tooltipClassName={isFullScreen ? theme.tooltipWidth : {}}
                smallTooltip
                tooltipHideOnHover={false}
                tooltip={isFullScreen ? t('exitFullScreen') : t('fullScreen')}
            >
                <Icon
                    onClick={this.onButtonClick}
                    theme={theme}
                    icon={isFullScreen ? 'full-screen-exit' : 'full-screen'}
                />
            </TooltipDiv>
        );
    }
}

export default translate('translations')(FullScreenIcon);
